import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import Authentication from './pages/authentication';
import MainDashboard from './pages/main-dashboard';
import LiveBroadcastingStudio from './pages/live-broadcasting-studio';
import AudioPlayerInterface from './pages/audio-player-interface';
import ChannelProfile from './pages/channel-profile';
import UserProfileSettings from './pages/user-profile-settings';
import SearchAndDiscovery from './pages/search-and-discovery';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<MainDashboard />} />
        <Route path="/authentication" element={<Authentication />} />
        <Route path="/main-dashboard" element={<MainDashboard />} />
        <Route path="/live-broadcasting-studio" element={<LiveBroadcastingStudio />} />
        <Route path="/audio-player-interface" element={<AudioPlayerInterface />} />
        <Route path="/channel-profile" element={<ChannelProfile />} />
        <Route path="/user-profile-settings" element={<UserProfileSettings />} />
        <Route path="/search-and-discovery" element={<SearchAndDiscovery />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
